// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-fluid {
	padding-left: 0 !important;
	min-height: 100vh;
}

.date-picker > .ant-picker-input {
	padding: 1.5px 0px !important;
}

.range-picker {
	height: 34.5px !important;
}

.dark {
	color: black;
}

.salelist-saleperson-input .ant-select-selector {
	height: 34.5px !important;
}

.salelist-search-btn {
	height: 34.5px !important;
	display: flex !important;
	justify-content: center;
	align-items: center;
}

.date-picker-transaction-create,
.hr-staffs-date-picker {
	height: 34.5px !important;
}

.user-btn {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
}

.ant-dropdown-menu {
	border-radius: 10px !important;
}

/* ====== START - Overriding ====== */

.ant-layout-header {
	background-color: transparent !important;
	padding: 0 !important;
}

.ant-select-selection-placeholder {
	padding: 2px 0 !important;
	line-height: 30px !important;
}

.ant-select-show-search.ant-select:not(.ant-select-customize-input)
	.ant-select-selector {
	height: 34px !important;
}

.ant-input-lg {
	font-size: 14px;
}

.ant-input-number-lg input {
	height: 25px !important;
}

.ant-form-item-control-input-content
	.ant-select-selector
	.ant-select-selection-search
	.ant-select-selection-search-input {
	height: 32px !important;
}

.ant-drawer-body {
	padding: 0 !important;
}

.ant-menu-dark .ant-menu-inline.ant-menu-sub {
	background-color: transparent;
}

.ant-menu-title-content > a {
	padding: 0 !important;
}

.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
	background-color: transparent !important;
}

.ant-menu-item .active {
	background-color: transparent !important;
}

.ant-layout {
	/* background-color: transparent; */
}

.totalMargin {
	margin-top: 8px !important;
}

.min-margin {
	margin-top: -25px !important;
}

.ant-layout-footer {
	padding: 24px !important;
	background-color: transparent !important;
}

.ant-menu-title-content a {
	color: inherit !important;
}

.ant-btn {
	border-radius: 5px !important;
	box-shadow: 0 2px 4px rgb(0 0 0 / 7%);
}

.ant-picker {
	width: 100%;
}

.ant-input-number {
	width: 100%;
}

.ant-select {
	width: 100%;
}

.ant-input,
.ant-select-selector {
	border-radius: 5px !important;
}

.ant-input {
	padding: 5.5px 11px !important;
}

/* .ant-select-selector {
  height: auto !important;
  padding: 2px 11px !important;
} */

.ant-picker,
.ant-input-number {
	/* border: 1px solid #d9d9d9 !important; */
	border-radius: 5px !important;
	padding: 5px 11px !important;
}

.ant-form-item-control-input-content .ant-picker {
}

/* .ant-select-selection-search {
  height: 38px !important;
} */

/* .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)
  .ant-select-selection-search-input {
  height: 20px !important;
} */

.ant-select-lg {
	font-size: 14px !important;
}

.ant-table {
	background-color: transparent !important;
}

.ant-input-affix-wrapper-status-error:not(
		.ant-input-affix-wrapper-disabled
	):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
.ant-input-affix-wrapper-status-error:not(
		.ant-input-affix-wrapper-disabled
	):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
	background: transparent;
	padding: 0 !important;
}

.ant-input-affix-wrapper {
	background: transparent;
	border-radius: 5px !important;
	padding: 0 !important;
	border-color: #ff4d4f;
}

.ant-switch {
	background-color: rgba(0, 0, 0, 0.25) !important;
}

.ant-switch-checked {
	background-color: #1890ff !important;
}

.ant-input-number-affix-wrapper-lg {
	padding: 0 !important;
}

.ant-input-number-affix-wrapper {
	border-radius: 5px !important;
}

.ant-btn-danger {
	background-color: #ff4d4f !important;
}

/* ====== END - Overriding ====== */

/* ====== Responsive ====== */

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,wBAAwB;CACxB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,qCAAqC;;AAErC;CACC,wCAAwC;CACxC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;;CAEC,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;;;CAIC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,wBAAwB;CACxB,wCAAwC;AACzC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,qCAAqC;AACtC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;;GAGG;;AAEH;;CAEC,0CAA0C;CAC1C,6BAA6B;CAC7B,4BAA4B;AAC7B;;AAEA;AACA;;AAEA;;GAEG;;AAEH;;;GAGG;;AAEH;CACC,0BAA0B;AAC3B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;;;;;;CAMC,uBAAuB;CACvB,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,qBAAqB;CACrB,qBAAqB;AACtB;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,oCAAoC;AACrC;;AAEA,mCAAmC;;AAEnC,6BAA6B;;AAE7B,sDAAsD;AACtD;AACA;;AAEA,8CAA8C;AAC9C;AACA;;AAEA,+CAA+C;AAC/C;AACA","sourcesContent":[".container-fluid {\n\tpadding-left: 0 !important;\n\tmin-height: 100vh;\n}\n\n.date-picker > .ant-picker-input {\n\tpadding: 1.5px 0px !important;\n}\n\n.range-picker {\n\theight: 34.5px !important;\n}\n\n.dark {\n\tcolor: black;\n}\n\n.salelist-saleperson-input .ant-select-selector {\n\theight: 34.5px !important;\n}\n\n.salelist-search-btn {\n\theight: 34.5px !important;\n\tdisplay: flex !important;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.date-picker-transaction-create,\n.hr-staffs-date-picker {\n\theight: 34.5px !important;\n}\n\n.user-btn {\n\tborder: none !important;\n\toutline: none !important;\n\tbox-shadow: none !important;\n}\n\n.ant-dropdown-menu {\n\tborder-radius: 10px !important;\n}\n\n/* ====== START - Overriding ====== */\n\n.ant-layout-header {\n\tbackground-color: transparent !important;\n\tpadding: 0 !important;\n}\n\n.ant-select-selection-placeholder {\n\tpadding: 2px 0 !important;\n\tline-height: 30px !important;\n}\n\n.ant-select-show-search.ant-select:not(.ant-select-customize-input)\n\t.ant-select-selector {\n\theight: 34px !important;\n}\n\n.ant-input-lg {\n\tfont-size: 14px;\n}\n\n.ant-input-number-lg input {\n\theight: 25px !important;\n}\n\n.ant-form-item-control-input-content\n\t.ant-select-selector\n\t.ant-select-selection-search\n\t.ant-select-selection-search-input {\n\theight: 32px !important;\n}\n\n.ant-drawer-body {\n\tpadding: 0 !important;\n}\n\n.ant-menu-dark .ant-menu-inline.ant-menu-sub {\n\tbackground-color: transparent;\n}\n\n.ant-menu-title-content > a {\n\tpadding: 0 !important;\n}\n\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n\tbackground-color: transparent !important;\n}\n\n.ant-menu-item .active {\n\tbackground-color: transparent !important;\n}\n\n.ant-layout {\n\t/* background-color: transparent; */\n}\n\n.totalMargin {\n\tmargin-top: 8px !important;\n}\n\n.min-margin {\n\tmargin-top: -25px !important;\n}\n\n.ant-layout-footer {\n\tpadding: 24px !important;\n\tbackground-color: transparent !important;\n}\n\n.ant-menu-title-content a {\n\tcolor: inherit !important;\n}\n\n.ant-btn {\n\tborder-radius: 5px !important;\n\tbox-shadow: 0 2px 4px rgb(0 0 0 / 7%);\n}\n\n.ant-picker {\n\twidth: 100%;\n}\n\n.ant-input-number {\n\twidth: 100%;\n}\n\n.ant-select {\n\twidth: 100%;\n}\n\n.ant-input,\n.ant-select-selector {\n\tborder-radius: 5px !important;\n}\n\n.ant-input {\n\tpadding: 5.5px 11px !important;\n}\n\n/* .ant-select-selector {\n  height: auto !important;\n  padding: 2px 11px !important;\n} */\n\n.ant-picker,\n.ant-input-number {\n\t/* border: 1px solid #d9d9d9 !important; */\n\tborder-radius: 5px !important;\n\tpadding: 5px 11px !important;\n}\n\n.ant-form-item-control-input-content .ant-picker {\n}\n\n/* .ant-select-selection-search {\n  height: 38px !important;\n} */\n\n/* .ant-select-single.ant-select-lg:not(.ant-select-customize-input):not(.ant-select-customize-input)\n  .ant-select-selection-search-input {\n  height: 20px !important;\n} */\n\n.ant-select-lg {\n\tfont-size: 14px !important;\n}\n\n.ant-table {\n\tbackground-color: transparent !important;\n}\n\n.ant-input-affix-wrapper-status-error:not(\n\t\t.ant-input-affix-wrapper-disabled\n\t):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,\n.ant-input-affix-wrapper-status-error:not(\n\t\t.ant-input-affix-wrapper-disabled\n\t):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {\n\tbackground: transparent;\n\tpadding: 0 !important;\n}\n\n.ant-input-affix-wrapper {\n\tbackground: transparent;\n\tborder-radius: 5px !important;\n\tpadding: 0 !important;\n\tborder-color: #ff4d4f;\n}\n\n.ant-switch {\n\tbackground-color: rgba(0, 0, 0, 0.25) !important;\n}\n\n.ant-switch-checked {\n\tbackground-color: #1890ff !important;\n}\n\n.ant-input-number-affix-wrapper-lg {\n\tpadding: 0 !important;\n}\n\n.ant-input-number-affix-wrapper {\n\tborder-radius: 5px !important;\n}\n\n.ant-btn-danger {\n\tbackground-color: #ff4d4f !important;\n}\n\n/* ====== END - Overriding ====== */\n\n/* ====== Responsive ====== */\n\n/* Small devices (landscape phones, less than 768px) */\n@media (max-width: 767.98px) {\n}\n\n/* Medium devices (tablets, less than 992px) */\n@media (max-width: 991.98px) {\n}\n\n/* Large devices (desktops, less than 1200px) */\n@media (max-width: 1199.98px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
